'use client';

import { isInStoryblok } from '@/helpers/client/storyblok';

export const pushDataLayerEvent = (event) => {
  if (typeof window !== 'undefined' && !isInStoryblok()) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(event);

    if (process.env.NODE_ENV === 'development') {
      console.log('dataLayer.push', event);
    }
  }
};
